import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of, switchMap } from 'rxjs';
import { ConfirmationDialogComponent, ConfirmationDialogData } from '../shared/components/confirmation-dialog/confirmation-dialog.component';
import { LoadschedulesComponent } from './loadschedules.component';

@Injectable({ providedIn: 'root' })
export class PendingChangesGuard implements CanDeactivate<LoadschedulesComponent> {

    constructor(private dialog: MatDialog) {}

    canDeactivate(component: LoadschedulesComponent): Observable<boolean> | boolean {

        // No pending changes — allow navigation freely
        if (!component.hasPendingStatusChanges()) return true;

        return this.dialog.open(ConfirmationDialogComponent, {
            disableClose: false,
            data: {
                title: 'Alert',
                panelClass: 'delete-confirmation-dialog-nowrap',
                message: 'You have unsaved status changes.<br />Would you like to save them before leaving?',
                confirmButtonText: 'Update Status',
                cancelButtonText: 'Cancel',
                confirmButtonColor: 'primary'
            } as ConfirmationDialogData
            }).afterClosed().pipe(
            switchMap((result: boolean | undefined) => {
                if (result === undefined || result === null) {
                    return of(false);
                }
                if (result === true) {
                    return component.updateStatusAndNavigate();
                }
                component.resetPendingChanges();
                return of(true);
            })
        );
    }
}